// Utility to handle Meta Pixel events safely
// We use a safe wrapper to avoid runtime errors if the package isn't installed in the environment
// but we follow the requested pattern where possible.

export const PIXEL_ID = '1451684529949109'

export const initPixel = () => {
  if (typeof window !== 'undefined') {
    import('react-facebook-pixel')
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.init(PIXEL_ID)
        ReactPixel.pageView()
      })
      .catch(() => {
        console.warn('ReactPixel not loaded, falling back to window.fbq')
        // Fallback if package is missing
        if ((window as any).fbq) {
          ;(window as any).fbq('init', PIXEL_ID)
          ;(window as any).fbq('track', 'PageView')
        }
      })
  }
}

export const trackAddToCart = () => {
  if (typeof window !== 'undefined') {
    import('react-facebook-pixel')
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.track('AddToCart', { value: 9.99, currency: 'USD' })
      })
      .catch(() => {
        if ((window as any).fbq) {
          ;(window as any).fbq('track', 'AddToCart', {
            value: 9.99,
            currency: 'USD',
          })
        }
      })
  }
}
